'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
	(function (ProductDetailParallax, $) {
		var $dom = {};

		var cacheDom = function cacheDom() {
			$dom.ProductParallaxContainer = $('[data-product-parallax-container]');
			$dom.ProductParallax = $('[data-product-parallax]');
			$dom.ContentBlock = $('[data-content-block]');
			$dom.ProductParallaxEnd = $('[data-product-parallax-end]');
			$dom.BottleParallax = $('[data-bottle-parallax]');
			$dom.DropletParallax = $('[data-droplet-parallax]');
		};

		var ProductDetailParallaxInit = function ProductDetailParallaxInit() {
			var offset = 350;
			//Product Parallax Variables
			var productHeight = $dom.ProductParallax.outerHeight();
			//Main Container Variables
			var containerHeight = $dom.ProductParallaxContainer.outerHeight();
			var containerOffset = $dom.ProductParallaxContainer.offset().top - offset;
			var containerOffsetBottom = $dom.ProductParallaxContainer.offset().top + containerHeight;
			if ($(window).width() > 992) {
				var animationEnd = containerOffsetBottom - $dom.ProductParallaxEnd.height() - offset - productHeight + 30;
			} else {
				var animationEnd = containerOffsetBottom - $dom.ProductParallaxEnd.height() - offset - productHeight - 160;
			}
			//First Block Variables
			var firstBlockHeight = $dom.ContentBlock.first().outerHeight();
			var firstBlockOffset = $dom.ContentBlock.first().offset().top - offset;
			var firstBlockEnd = firstBlockHeight + firstBlockOffset;
			//Last Block Variables
			var lastBlockHeight = $dom.ContentBlock.last().outerHeight();
			var lastBlockOffset = $dom.ContentBlock.last().offset().top - offset;
			var lastBlockEnd = lastBlockHeight + lastBlockOffset;

			var Parallax = function Parallax() {
				//Position Animation
				if ($(window).width() > 992) {
					if ($(window).scrollTop() > containerOffset && $(window).scrollTop() < animationEnd) {
						var topPosition = $(window).scrollTop() - firstBlockOffset;
						if (topPosition < 0) {
							topPosition = 0;
						}
						$dom.ProductParallax.css('top', topPosition);
					} else if ($(window).scrollTop() >= animationEnd) {
						var topPosition = animationEnd - firstBlockOffset;
						$dom.ProductParallax.css('top', topPosition);
					}
				} else {
					if ($(window).scrollTop() > firstBlockEnd + 450 && $(window).scrollTop() < animationEnd) {
						var topPosition = $(window).scrollTop() - firstBlockOffset - 150;
						if (topPosition < 0) {
							topPosition = 0;
						}
						$dom.ProductParallax.css('top', topPosition);
					} else if ($(window).scrollTop() >= animationEnd) {
						var topPosition = animationEnd - firstBlockOffset - 150;
						$dom.ProductParallax.css('top', topPosition);
					}
				}
				//Fade in/out Animation
				if ($(window).width() > 992) {
					if ($(window).scrollTop() > firstBlockOffset / 2) {
						var opacityPercentage = ($(window).scrollTop() - firstBlockOffset) / (firstBlockHeight / 4);
						if (opacityPercentage <= 1 && opacityPercentage >= 0) {
							$dom.ProductParallax.css('opacity', opacityPercentage);
						} else if (opacityPercentage < 0) {
							$dom.ProductParallax.css('opacity', 0);
						} else {
							$dom.ProductParallax.css('opacity', 1);
						}
					}
				} else {
					if ($(window).scrollTop() > firstBlockEnd + 250) {
						var opacityPercentage = ($(window).scrollTop() - firstBlockEnd - 250) / (firstBlockHeight / 5);
						if (opacityPercentage <= 1 && opacityPercentage >= 0) {
							$dom.ProductParallax.css('opacity', opacityPercentage);
						} else if (opacityPercentage < 0) {
							$dom.ProductParallax.css('opacity', 0);
						} else {
							$dom.ProductParallax.css('opacity', 1);
						}
					}
				}
				//Bottle Animation
				if ($(window).width() > 992) {
					if ($(window).scrollTop() > firstBlockEnd && $(window).scrollTop() < animationEnd) {
						var topPosition = ($(window).scrollTop() - firstBlockOffset - productHeight) / 2;
						if (topPosition < 0) {
							topPosition = 0;
						}
						$dom.BottleParallax.css('top', topPosition);
						$dom.BottleParallax.css('opacity', 1);
					} else if ($(window).scrollTop() > firstBlockEnd) {
						var topPosition = ($(window).scrollTop() - firstBlockOffset - productHeight) / 2;
						var opacityPercentage = 1 - ($(window).scrollTop() - lastBlockOffset) / (lastBlockHeight / 2);
						if (opacityPercentage <= 1 && opacityPercentage >= 0) {
							$dom.BottleParallax.css('opacity', opacityPercentage);
							$dom.BottleParallax.show();
						} else if (opacityPercentage < 0) {
							$dom.BottleParallax.css('opacity', 0);
							$dom.BottleParallax.hide();
						} else {
							$dom.BottleParallax.css('opacity', 1);
							$dom.BottleParallax.show();
						}
						$dom.BottleParallax.css('top', topPosition);
					} else {
						$dom.BottleParallax.css('top', 0);
					}
				} else {
					if ($(window).scrollTop() > firstBlockEnd && $(window).scrollTop() < animationEnd) {
						var topPosition = ($(window).scrollTop() - firstBlockEnd - productHeight) / 2;
						if (topPosition < 0) {
							topPosition = 0;
						}
						$dom.BottleParallax.css('top', topPosition);
						$dom.BottleParallax.css('opacity', 1);
					} else if ($(window).scrollTop() > firstBlockEnd) {
						var topPosition = ($(window).scrollTop() - firstBlockEnd - productHeight) / 2;
						var opacityPercentage = 1 - ($(window).scrollTop() - lastBlockOffset) / (lastBlockHeight / 2);
						if (opacityPercentage <= 1 && opacityPercentage >= 0) {
							$dom.BottleParallax.css('opacity', opacityPercentage);
							$dom.BottleParallax.show();
						} else if (opacityPercentage < 0) {
							$dom.BottleParallax.css('opacity', 0);
							$dom.BottleParallax.hide();
						} else {
							$dom.BottleParallax.css('opacity', 1);
							$dom.BottleParallax.show();
						}
						$dom.BottleParallax.css('top', topPosition);
					} else {
						$dom.BottleParallax.css('top', 0);
					}
				}
				//Droplet Fade in/out Animation
				if ($(window).scrollTop() > animationEnd) {
					var opacityPercentage = ($(window).scrollTop() - lastBlockOffset) / (lastBlockHeight / 3);
					if (opacityPercentage <= 1 && opacityPercentage >= 0) {
						$dom.DropletParallax.css('opacity', opacityPercentage);
					} else if (opacityPercentage < 0) {
						$dom.DropletParallax.css('opacity', 0);
					} else {
						$dom.DropletParallax.css('opacity', 1);
					}
				} else if ($(window).scrollTop() < animationEnd) {
					$dom.DropletParallax.css('opacity', 0);
				}
			};
			Parallax();
			$(window).on('scroll', function () {
				Parallax();
			});
		};

		ProductDetailParallax.init = function () {
			cacheDom();
			$(window).on('load', function () {
				if ($dom.ProductParallax.length > 0) {
					ProductDetailParallaxInit();
				}
			});
		};
	})(window.ProductDetailParallax = window.ProductDetailParallax || {}, _jquery2.default, undefined);
};